if (!customElements.get('wlsn-form-modal')) {
    class WLSNFormModal extends HTMLElement {
        constructor() {
            super();

            this.openClass = 'is-open';
            this.bodyLockClass = 'body-lock';
            this.triggerClass = 'js-wlsn-form-modal-trigger';
            this.closeClass = 'js-wlsn-form-modal-close';

            this.handleDocumentClick = this.handleDocumentClick.bind(this);
        }

        connectedCallback() {
            this.wrapper = this.querySelector('.wlsn-form-modal__wrapper');
            document.addEventListener('click', this.handleDocumentClick);
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.handleDocumentClick);
        }

        open() {
            this.classList.add(this.openClass);
            document.body.classList.add(this.bodyLockClass);
        }

        close() {
            this.classList.remove(this.openClass);
            document.body.classList.remove(this.bodyLockClass);
        }

        handleDocumentClick(e) {
            const trigger = e.target.closest(`.${this.triggerClass}`);
            const closeBtn = e.target.closest(`.${this.closeClass}`);

            if (trigger) {
                e.preventDefault();     
                e.stopPropagation();  
                this.open();
                return;
            }

            if (closeBtn) {
                e.stopPropagation();
                this.close();
                return;
            }

            if (this.classList.contains(this.openClass) && !this.wrapper.contains(e.target)) {
                this.close();
            }
        }
    }

    customElements.define('wlsn-form-modal', WLSNFormModal);
}